import gql from 'graphql-tag';

const GOOGLE_OAUTH_AUTHORIZE = gql`
  query googleOAuthAuthorize($orgId: String!) {
    googleOAuthAuthorize(orgId: $orgId)
  }
`;

export default GOOGLE_OAUTH_AUTHORIZE;
